<template>
  <div>
    <view-table
        ref="vmTable"
        url="materialLabelPrints/page/record"
        :filter="filter"
        :columns-property="columnsProperty"
        module="basic"
        @select="handleSelection"
        @reset="handleReset">
      <template #otherBtn>
        <el-button :loading="loading" type="primary" @click="handleReprint">补打</el-button>
      </template>
      <template #adSearch>
        <el-form :inline="true" :model="filter" @keyup.enter.native="getList(1)">
          <el-form-item label="关联单号">
            <el-input v-model.trim="filter.relBillNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="物料号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="模板名称">
            <el-input v-model.trim="filter.templateName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="打印参数">
            <el-input v-model.trim="filter.printParams" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="打印时间">
            <el-date-picker
                v-model="printDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="printDateChange"/>
          </el-form-item>
        </el-form>
      </template>
    </view-table>
  </div>
</template>

<script>

  import ViewTable from "@/components/ViewTable.vue";

  export default {
    name: "MaterialLabelPrintRecordList",
    components: {ViewTable},
    data() {
      return {
        loading: false,
        rePrintAuth: this.$auth(732),
        printDateRange: [],
        selection: [],
        filter: {
          relBillNo: "",
          materialNo: "",
          templateName: "",
          printParams: "",
          startDate: "",
          endDate: "",
          updateDate: "",
        },
        columnsProperty: [
          {
            key: "relBillNo",
            width: 150,
            align: "center",
          },
          {
            key: "materialNo",
            width: 150,
            align: "center",
          },
          {
            key: "templateTypeName",
            width: 150,
            align: "center",
          },
          {
            key: "templateName",
            width: 200,
            align: "center",
          },
          {
            key: "customerName",
            width: 200,
            toolTip: true,
          },
          {
            key: "printParams",
            minWidth: 300,
            toolTip: true,
          },
          {
            key: "updateName",
            width: 150,
            align: "center",
          },
          {
            key: "updateTime",
            width: 180,
            align: "center",
          },
        ],
      };
    },
    mounted() {
      // this.getList(1);
    },
    methods: {
      getList(num) {
        this.$refs.vmTable.loadData(num);
      },
      printDateChange(date) {
        if (date) {
          this.filter.startDate = date[0];
          this.filter.endDate = date[1];
        } else {
          this.filter.startDate = "";
          this.filter.endDate = "";
        }
      },
      handleReset(filter) {
        this.filter = Object.assign(this.filter, filter);
        this.printDateRange = [];
      },
      handleSelection(selection) {
        this.selection = selection;
      },
      handleReprint() {
        if (this.selection.length < 1) {
          return this.$message.error("请选择需要打印的行项");
        }
        this.loading = true;
        this.$http
          .postForFile("basic", "materialLabelPrints/repeat", this.selection)
          .then((res) => {
            if (res) {
              let blob = new Blob([res.data], {type: "application/pdf"});
              let pdfUrl = window.URL.createObjectURL(blob);
              let newWindow = window.open(pdfUrl, "__blank");
              newWindow.document.close();
              newWindow.print();
            } else {
              this.$message.error("未获取到打印信息");
            }
          }).finally(() => {
            this.loading = false;
          });
      },
    },
  };
</script>

<style scoped>

</style>
